import dateString from 'helpers/generators/date-string'
import timeString from 'helpers/generators/time-string'

export const dateTimeString = () => dateString() + timeString()

export default dateTimeString
